




























import { Component, Vue } from "vue-property-decorator";

@Component
export default class SelectContentTemplateType extends Vue {
    // methods
    open() {
        this.$bvModal.show("modal-select-template-type");
    }

    selectTemplateType(type: string) {
        if (type === "html") this.$router.push({ name: "createHtmlTemplate" });
        if (type === "fixedHtml") this.$router.push({ name: "createFixedHtmlTemplate" });
    }
}
